import { render, staticRenderFns } from "./lost.vue?vue&type=template&id=9372ff4c&scoped=true&"
import script from "./lost.vue?vue&type=script&lang=js&"
export * from "./lost.vue?vue&type=script&lang=js&"
import style0 from "./lost.vue?vue&type=style&index=0&id=9372ff4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9372ff4c",
  null
  
)

export default component.exports